import React from 'react';
import ReactDOM from 'react-dom/client'; // Beachten Sie das '/client' für React 18+
import App from './App'; // Stellen Sie sicher, dass der Pfad zu Ihrer App.js korrekt ist

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);